import {SET_ERRORS} from "./actionTypes";

export const setErrors = errors => ({
  type: SET_ERRORS,
  payload: errors
});


// WEBPACK FOOTER //
// ./src/store/actions/error.js